import { all, call, put, takeLatest } from 'redux-saga/effects';

import { deleteInspection, getContacts, getTaxAuthoritiesSuccessors } from '../../services/API';
import {
  actionTypes,
  deleteRequestFailure,
  deleteRequestSuccess,
  requestFailure,
  requestSuccess,
} from './actions';

function* getData() {
  const [contactsResponse, successorsResponse] = yield all([
    call(getContacts),
    call(getTaxAuthoritiesSuccessors),
  ]);

  if (contactsResponse.isOk && successorsResponse.isOk) {
    yield put(requestSuccess(contactsResponse.data, successorsResponse.data));
  } else {
    yield put(requestFailure(contactsResponse.error));
  }
}

function* deleteData(action) {
  const response = yield call(deleteInspection, action.payload);
  yield put(
    response.isOk
      ? deleteRequestSuccess(action.payload)
      : deleteRequestFailure(response.error, action.payload),
  );
}

export default function* contactsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
  yield takeLatest(actionTypes.DELETE_REQUEST_START, deleteData);
}
